/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
 */
export const FEATURE_CSV_IMPORT = 'csv-import';
export const FEATURE_CSV_EXPORT = 'csv-export';
export const FEATURE_SESSION_REPORT = 'session-report';
export const FEATURE_INDIVIDUAL_REPORT = 'individual-report';
export const FEATURE_USERS = 'users';
export const FEATURE_GROUPS = 'groups';
export const FEATURE_CONTENT_BANK = 'content-bank';
export const FEATURE_BATTERIES = 'batteries';
export const FEATURE_SESSIONS = 'sessions';
export const FEATURE_STUDENT_SESSIONS = 'student-sessions';
export const FEATURE_HIERARCHIES = 'hierarchies';
export const FEATURE_LABS = 'labs';
export const FEATURE_EXPERIMENTAL = 'tags';
export const FEATURE_CUSTOM_REPORTS = 'custom-reports';
export const FEATURE_CAMPAIGNS = 'campaigns';
export const FEATURE_DELIVERIES = 'deliveries';
export const FEATURE_IMPORT_DELIVERIES = 'import-deliveries';
export const FEATURE_SESSION_TEMPLATES = 'session-templates';
export const FEATURE_CERTIFICATION_SESSIONS = 'certification-sessions';
export const FEATURE_SUPPORT = 'support';
export const FEATURE_TESTS = 'tests';
export const FEATURE_DATA_EXPLORER = 'data-explorer';
export const FEATURE_CANDIDATES = 'candidates';
// access My profile page
export const FEATURE_ACCOUNT_SETTINGS = 'account-settings';
export const FEATURE_CREATE_PUBLIC_SESSIONS = 'create-public-sessions';
export const FEATURE_ACCESS_PUBLIC_SESSIONS = 'access-public-sessions';

// features that have no corresponding feature flag
export const CORE_FEATURES = [
    FEATURE_USERS,
    FEATURE_DELIVERIES,
    FEATURE_IMPORT_DELIVERIES,
    FEATURE_CONTENT_BANK,
    FEATURE_SESSIONS,
    FEATURE_CSV_IMPORT,
    FEATURE_INDIVIDUAL_REPORT,
    FEATURE_CSV_EXPORT,
    FEATURE_SESSION_REPORT,
    FEATURE_LABS,
    FEATURE_EXPERIMENTAL,
    FEATURE_ACCOUNT_SETTINGS,
    FEATURE_BATTERIES,
    FEATURE_DATA_EXPLORER
];
